<template>

  <v-card
    :disabled="!expand && !completed"
    class="col-12 pa-0 mb-4 bt-step-card"
  >
    <v-card-title>
      {{ title }}
      <v-spacer />
      <v-btn
        v-if="expand"
        :disabled="!valid || !expand"
        small
        color="primary"
        @click="complete"
      >
        Next step
      </v-btn>
    </v-card-title>
    <v-divider v-if="expand" />

    <v-card-text class="pa-0">
      <v-expand-transition>
        <v-form
          v-if="expand"
          v-model="valid"
        >
          <v-container>

            <fieldset
              class="currency-config-group rounded-8"
            >
              <legend class="px-3">
                Amount

                <v-switch
                  color="green"
                  class="mt-0 ml-2"
                  hide-details
                  v-model="value.amount_in_percent"
                  :label="value.amount_in_percent ? 'Percent, add max amount' : 'By Currency'"
                />

                <v-hover v-slot="{ hover }">
                  <v-icon :color="hover ? 'success' : ''" class="ml-2" @click="!value.amount_in_percent ? addCurrency() : addAmountLimit()">mdi-plus-circle-outline</v-icon>
                </v-hover>
              </legend>

              <v-row
                v-if="!value.amount_in_percent"
                class="ma-0 pb-3"
                justify="center"
              >
                <v-card
                  v-for="(v,k) in value.amounts"
                  :key="'bonus-currency-settings_amount' + k"
                  class="ma-2"
                  style="width: 220px;"
                >
                  <v-card-text class="pa-2">
                    <div class="float-right currency-config-action">
                      <v-hover v-if="value.amounts.length > 1" v-slot="{ hover }">
                        <v-icon :color="hover ? 'error' : ''" @click="removeCurrency(k)">mdi-minus-circle-outline</v-icon>
                      </v-hover>
                    </div>

                    <v-row class="ma-0">

                      <v-text-field
                        label="Amount"
                        class="col-6"
                        placeholder="."
                        v-model="value.amounts[k].amount"
                        :rules="[v => !!v || 'Amount is required']"
                        hide-details
                        required
                      />
                      <v-select
                        label="Currency"
                        class="col-6"
                        v-model="value.amounts[k].currency"
                        :items="value.amounts[k].currency ? [value.amounts[k].currency, ...toArray(currenciesAmount)] : currenciesAmount"
                        placeholder=" "
                        :rules="[v => !!v || 'Currency is required']"
                        hide-details
                      />
                    </v-row>

                  </v-card-text>
                </v-card>
              </v-row>


              <template v-else>

                <v-row
                  justify="center"
                >
                  <v-card
                    class="ma-2"
                    style="width: 220px;"
                  >
                    <v-card-text class="pt-2">

                      <v-text-field
                        label="Amount"
                        placeholder="."
                        v-model="value.amount_percent"
                        :rules="[v => !!v || 'Amount is required']"
                        hide-details
                        required
                        suffix="%"
                      />
                    </v-card-text>
                  </v-card>
                </v-row>

                <v-row
                  class="ma-0 pb-3"
                  justify="center"
                >
                  <v-card
                    v-for="(v,k) in value.amount_limits"
                    :key="'bonus-currency-settings_amount_limits' + k"
                    class="ma-2"
                    style="width: 220px;"
                  >
                    <v-card-text class="pa-2">
                      <div class="float-right currency-config-action">
                        <v-hover v-slot="{ hover }">
                          <v-icon :color="hover ? 'error' : ''" @click="removeAmountLimit(k)">mdi-minus-circle-outline</v-icon>
                        </v-hover>
                      </div>

                      <v-row class="ma-0">

                        <v-text-field
                          label="Max Amount"
                          class="col-6"
                          placeholder="."
                          v-model="value.amount_limits[k].amount"
                          :rules="[v => !!v || 'Amount is required']"
                          hide-details
                          required
                        />
                        <v-select
                          label="Currency"
                          class="col-6"
                          v-model="value.amount_limits[k].currency"
                          :items="value.amount_limits[k].currency ? [value.amount_limits[k].currency, ...toArray(currenciesAmount)] : currenciesAmount"
                          placeholder=" "
                          :rules="[v => !!v || 'Currency is required']"
                          hide-details
                        />
                      </v-row>

                    </v-card-text>
                  </v-card>
                </v-row>
              </template>
            </fieldset>

            <fieldset
              class="currency-config-group rounded-8 my-3"
            >
              <legend class="px-3">
                Max. Release
                <template v-if="value.type == 'freespins'"> / Max. FS Win</template>
                <v-hover v-slot="{ hover }">
                  <v-icon :color="hover ? 'success' : ''" class="ml-2" @click="addOption">mdi-plus-circle-outline</v-icon>
                </v-hover>
              </legend>

              <v-row
                class="ma-0 pb-3"
                justify="center"
              >
                <v-card
                  v-for="(v,k) in value.options"
                  :key="'bonus-currency-settings_options' + k"
                  class="ma-2"
                  :style="{width: value.type == 'freespins' ? '350px' : '220px'}"
                >
                  <v-card-text class="pa-2">
                    <div class="float-right currency-config-action">
                      <v-hover v-slot="{ hover }">
                        <v-icon :color="hover ? 'error' : ''" @click="removeOption(k)">mdi-minus-circle-outline</v-icon>
                      </v-hover>
                    </div>

                    <v-row class="ma-0">

                      <v-text-field
                        label="Max Release"
                        :class="{'col-6': value.type !== 'freespins','col-4': value.type == 'freespins'}"
                        placeholder="."
                        v-model="value.options[k].max_release"
                        :rules="[v => !!v || 'Max Release is required']"
                        hide-details
                        required
                      />
                      <v-text-field
                        v-if="value.type == 'freespins'"
                        label="Max FS Win"
                        class="col-4"
                        placeholder="."
                        v-model="value.options[k].max_fs_win"
                        :rules="[v => !!v || 'Max FS Win is required']"
                        hide-details
                        required
                      />
                      <v-select
                        label="Currency"
                        :class="{'col-6': value.type !== 'freespins','col-4': value.type == 'freespins'}"
                        v-model="value.options[k].currency"
                        :items="value.options[k].currency ? [value.options[k].currency, ...toArray(currenciesOptions)] : currenciesOptions"
                        placeholder=" "
                        :rules="[v => !!v || 'Currency is required']"
                        hide-details
                      />
                    </v-row>

                  </v-card-text>
                </v-card>
              </v-row>
            </fieldset>

          </v-container>
        </v-form>
      </v-expand-transition>
    </v-card-text>
  </v-card>

</template>

<style lang="scss">

  .v-card.v-card--disabled .v-card__title {
    background: #cbcbcb;
  }

  .v-card.v-card--disabled.bt-step-card {
    border-left-color: gray;
  }

  .v-card.bt-step-card {
    border-left: 4px solid #4caf50;
  }

  .currency-config-group legend {
    margin-left: 30px;
    padding-left: 5px;
    font-weight: bold;
  }

  .currency-config-group {
    border: thin solid #e1e0e0;
  }

  .currency-config-action {
    position: absolute;
    right: 3px;
    top: 3px;
    z-index: 5
  }

  .currency-config-group legend .v-input--switch {
    //width: 235px;
    display: inline-block;
    zoom: 0.9;
    padding: 0;
    bottom: -3px;
    position: relative;
  }

  //.currency-config-group legend .v-input--switch .v-label {
  //  font-size: 14px;
  //}

</style>

<script>
  import { filter, includes, map, toArray } from 'lodash'

  export default {

    props: {
      step: {},
      value: {},
      next: {},
      games: {},
      brands: {},
      systems: {},
      extvalid: {},
      exteditable: {},
      extcompleted: {},
      title: {},
      types: {},
      expand: { default: () => false },
    },

    data: () => ({
      // valid: false
    }),

    methods: {
      toArray,
      addCurrency () {
        if (!this.value.amounts) this.$set(this.value, 'amounts', [])
        if (this.currenciesAmount.length == 0) return

        this.value.amounts.push({ currency: this.currenciesAmount[0] })
      },

      removeCurrency (index) {
        this.value.amounts.splice(index, 1)
      },

      addAmountLimit () {
        if (!this.value.amount_limits) this.$set(this.value, 'amount_limits', [])
        if (this.currenciesAmountLimit.length == 0) return

        this.value.amount_limits.push({ currency: this.currenciesAmountLimit[0] })
      },

      removeAmountLimit (index) {
        this.value.amount_limits.splice(index, 1)
      },

      addOption () {
        if (!this.value.options) this.$set(this.value, 'options', [])
        if (this.currenciesOptions.length == 0) return

        this.value.options.push({ currency: this.currenciesOptions[0] })
      },

      removeOption (index) {
        this.value.options.splice(index, 1)
      },

      complete () {
        this.completed = true
        this.next(this.step)
      }
    },

    computed: {
      settings: function () {
        return this.types[this.value.type] || {}
      },
      currenciesAmountLimit: function () {
        return filter(this.$store.state.auth.currencies, o => !includes(this.selectedAmountLimitCurrencies, o))
      },
      selectedAmountLimitCurrencies () {
        return filter(map(this.value.amount_limits, o => o.currency), o => !!o)
      },
      currenciesAmount: function () {
        return filter(this.$store.state.auth.currencies, o => !includes(this.selectedAmountCurrencies, o))
      },
      selectedAmountCurrencies () {
        return filter(map(this.value.amounts, o => o.currency), o => !!o)
      },
      currenciesOptions: function () {
        return filter(this.$store.state.auth.currencies, o => !includes(this.selectedOptionsCurrencies, o))
      },
      selectedOptionsCurrencies () {
        return filter(map(this.value.options, o => o.currency), o => !!o)
      },
      valid: {
        get () {
          return this.extvalid
        },
        set (v) {
          this.$emit('update:extvalid', v)
        }
      },
      editable: {
        get () {
          return this.exteditable
        },
        set (v) {
          this.$emit('update:exteditable', v)
        }
      },
      completed: {
        get () {
          return this.extcompleted
        },
        set (v) {
          this.$emit('update:extcompleted', v)
        }
      },
    },

    watch: {
      expand (v) {
        this.editable = true
        if (!this.value.amounts || this.value.amounts.length == 0) {
          this.addCurrency()
        }
      },
      'value.type': function () {
        this.$set(this.value, 'amounts', [])
        this.$set(this.value, 'amount_limits', [])
        this.$set(this.value, 'options', [])
      }
    }
  }
</script>

